/* eslint-disable no-param-reassign */
const searchBar = document.querySelector('.js-search-bar');
const searchField = searchBar.querySelector('#search-field');
const searchSubmitBtn = searchBar.querySelector('.search-btn');
const stateNames = document.querySelectorAll('.location-index .card a');
const cardContainer = document.querySelectorAll('.card-container')[0];
const pageNames = document.querySelectorAll('.search-container .page-link a');
const searchCategory = document.querySelectorAll('.page-category');
const mainContainer = document.querySelector('main');
/**
 * Polyfill for parents method
 * @param {*} selector
 */
function parents(selector) {
  const elements = [];
  let elem = this;
  const isHaveSelector = selector !== undefined;

  while ((elem = elem.parentElement) !== null) { //eslint-disable-line
    if (elem && elem.nodeType !== window.Node.ELEMENT_NODE) {
      continue; //eslint-disable-line
    }

    if (!isHaveSelector || (elem && elem.matches(selector))) {
      elements.push(elem);
    }
  }

  return elements;
}

window.Element.prototype.parents = parents;

function displayLocationSearchResults() {
  const searchString = searchField.value.toLowerCase();
  const filterStates = Object.values(stateNames).filter(
    state => state.textContent.toLowerCase().indexOf(searchString) >= 0,
  );
  let html = '';
  filterStates.forEach((item) => {
    html = `${html}<li class="card"><a href=${item.href}>${item.innerHTML}</a></li>`;
  });
  const searchResultContainer = cardContainer;
  searchResultContainer.innerHTML = html;
}

function displaySitemapSearchResults() {
  const searchString = searchField.value.toLowerCase();
  const filteredPages = Object.values(pageNames).filter(
    page => page.textContent.toLowerCase().indexOf(searchString) >= 0,
  );
  pageNames.forEach((pageName) => {
    pageName.parentElement.style.display = 'none';
  });
  searchCategory.forEach((category) => {
    category.style.display = 'none';
  });
  if (filteredPages.length > 0) {
    if (mainContainer.classList.contains('no-results')) mainContainer.classList.remove('no-results');
    filteredPages.forEach((item) => {
      item.parentElement.style.display = 'block';
      item.parents('.page-category')[0].style.display = 'block';
    });
  } else {
    mainContainer.classList.add('no-results');
  }
}

window.addEventListener('load', () => {
  if (document.querySelector('#location-search-bar')) {
    searchField.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) displayLocationSearchResults();
    });
    searchSubmitBtn.addEventListener('click', displayLocationSearchResults);
  }
  if (document.querySelector('#sitemap-search-bar')) {
    searchField.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) displaySitemapSearchResults();
    });
  }
});
